import { Component, OnInit, Inject, Output, EventEmitter, ElementRef } from '@angular/core';
import { Location, PlatformLocation } from '@angular/common';
import { NotificationService } from '../../../services/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiserviceService } from '../../../services/apiservice.service';
import { CommonfunctionService } from '../../../services/commonfunction.service';
import { ShareService } from '../../../services/share.service';
import { Validators, UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { debounceTime, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { CustomizeAttributeList, ConfirmExit } from '../../dynamic/block3/block3.component';
import { _isNumberValue } from '@angular/cdk/coercion';


/**
 *
 * <strong>List of API using</strong>
 * <ol>
 * <li>estapi_module_type_assignment_name_properties_property_id_floors_floor_id_units_unit_id_patch</li>
 * <li>estapi_entity_masters_master_id_values_get</li>
 * <li>estapi_attribute_measure_unit_type_measureunits_get</li>
 * <li>estapi_attribute_measureunittypes_get</li>
 * </ol>
 *
 */


@Component({
  selector: 'app-edit-unit',
  templateUrl: './edit-unit.component.html',
  styleUrls: ['./edit-unit.component.css']
})
export class EditUnitComponent implements OnInit {
private subscriptions = new Subscription(); // initialize here
  mobile: boolean = false;
  linked_master : any = [];
  is_valid = false;
  dHeight: number;
  selected_property: any;
  selected_group: any;
  selected_sub_group: any;
  attribute_list: any;
  group_id: number;
  group_name: string;
  masterIDs: any = [];
  group_attribute: any = [];
  used_attribute: any = [];
  customize_attribute: Array<CustomizeAttributeList>;
  masters: any = [];
  master_val = [];
  measure_unit_type: any = [];
  years = [];
  selectedValues:any = [];
  newlist: any = [];
  active_field:any = {
    id:null,
    label : null
  };

  resource_access: any;
  month = [
    {
      "id": 1,
      "abbreviation": "Jan",
      "name": "January"
    },
    {
      "id": 2,
      "abbreviation": "Feb",
      "name": "February"
    },
    {
      "id": 3,
      "abbreviation": "Mar",
      "name": "March"
    },
    {
      "id": 4,
      "abbreviation": "Apr",
      "name": "April"
    },
    {
      "id": 5,
      "abbreviation": "May",
      "name": "May"
    },
    {
      "id": 6,
      "abbreviation": "Jun",
      "name": "June"
    },
    {
      "id": 7,
      "abbreviation": "Jul",
      "name": "July"
    },
    {
      "id": 8,
      "abbreviation": "Aug",
      "name": "August"
    },
    {
      "id": 9,
      "abbreviation": "Sep",
      "name": "September"
    },
    {
      "id": 10,
      "abbreviation": "Oct",
      "name": "October"
    },
    {
      "id": 11,
      "abbreviation": "Nov",
      "name": "November"
    },
    {
      "id": 12,
      "abbreviation": "Dec",
      "name": "December"
    }
  ];

  propertyForm: UntypedFormGroup;
  property_detail: any = null;
  is_submited = false;
  child_master_val: any = {};
  loader: boolean = false;
  unit: any;
  assignment_detail:any;
  rejected_attribute : any;
  image_upload:boolean=false;
  @Output() notif: EventEmitter<string> = new EventEmitter<string>();
  rejectmessage: any;
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<EditUnitComponent>, private readonly share: ShareService, private readonly route: Router, private readonly api: ApiserviceService, private readonly fb: UntypedFormBuilder,
    private readonly fnc: CommonfunctionService, private readonly location: Location, private readonly elementRef: ElementRef, private readonly notify: NotificationService, private readonly plocation: PlatformLocation,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    let s = this.share.floor_map_obj.unit_Uids[0];
    this.unit = this.share.floor_map_obj.getUnitDetail(s);
    this.mobile = this.share.mobile;
    this.assignment_detail = JSON.parse(localStorage.getItem('assignment_detail'));
    let date = new Date();
    let current_year = date.getFullYear();
    let start = current_year - 30;
    for (start; start < current_year + 30; start++) {
      this.years.push(start);
    }
    this.selected_property = this.share.block1_obj.selected_property;
    if (this.share.block0_obj.entity_type == "property") {
      this.resource_access = this.share.block0_obj.property_access;
      this.selected_group = this.share.block1_obj.selected_group;
      this.group_id = this.selected_group.id;
      this.group_name = this.selected_group.group_name;
      if (this.share.block2_obj) {
        this.selected_sub_group = this.share.block2_obj.selected_sub_group;
        this.group_id = this.selected_sub_group.id;
        this.group_name = this.selected_sub_group.group_name;
      }
      this.attribute_list = this.fnc.getChildArray('group_id', this.group_id, this.share.block0_obj.attribute_custom_list);
      this.rejected_attribute = this.share.block0_obj.rejectedAttributeList;
    }
    if (this.share.block0_obj.entity_type == "property_floor") {
      this.resource_access = this.share.block0_obj.floor_access;
      this.selected_group = this.share.floor_group_obj.selected_group;
      this.group_id = this.selected_group.id;
      this.group_name = this.selected_group.group_name;
      if (this.share.floor_subgroup_obj) {
        this.selected_sub_group = this.share.floor_subgroup_obj.selected_sub_group;
        if (this.selected_sub_group) {
          this.group_id = this.selected_sub_group.id;
          this.group_name = this.selected_sub_group.group_name;
        }
      }
      this.attribute_list = this.fnc.getChildArray('group_id', this.group_id, this.share.block0_obj.attribute_custom_list_floor);
      this.rejected_attribute = this.share.floor_obj.rejectedFloorAttributeList;
    }
    if (this.share.block0_obj.entity_type == "property_unit") {
      this.resource_access = this.share.block0_obj.unit_access;
      // this.selected_group = this.share.unit_group_obj.selected_group;
      //this.group_id = this.selected_group.id;
      //.group_name = this.selected_group.group_name;
      // if (this.share.unit_subgroup_obj) {
      //   this.selected_sub_group = this.share.unit_subgroup_obj.selected_sub_group;
      //   if (this.selected_sub_group) {
      //     this.group_id = this.selected_sub_group.id;
      //     this.group_name = this.selected_sub_group.group_name;
      //   }
      // }
      this.attribute_list = this.fnc.getChildArray('quick_edit', true, this.share.block0_obj.attribute_custom_list_unit);
      this.rejected_attribute = this.share.unit_obj.rejectedUnitAttributeList;
    }
    this.freezAttribute();
    this.createFormGroup();
    this.getMeasureUnitType();
    this.share.block0_obj.getAllowResource();
  }
  switchImage(){
    this.image_upload = true;
  }
  backFormSec(){
    this.image_upload = false;
  }

  freezAttribute(){
    let is_old = false;
    if(this.property_detail){
      if(this.property_detail.status != 1) is_old = true;
    }
    if ((this.selected_property.status == 4 || this.selected_property.status == 6) && is_old) {
      this.attribute_list.forEach((e, k) => {
      e.is_editable = false;
        if(this.fnc.getArrayValue('keyId',e.id,this.rejected_attribute)){
          e.is_editable = true;
        }
      });
      // this.customize_attribute.forEach((e)=>{
      //   e.is_editable = false;
      //   if(this.fnc.getArrayValue('keyId',e.id,this.rejected_attribute)){

      //   }
      // });
     }
  }

  setPropertyDetail() {
    if (this.share.block0_obj.entity_type == 'property_unit') {
      this.property_detail = this.share.unit_obj.unit_detail;
    }
  }
  createFormElement() {
    if (this.share.block0_obj.table_master_val.length > 0 && this.master_val.length == 0) {
      this.master_val = this.share.block0_obj.table_master_val;
    }
    let group = this.fb.group({});
    let tbl_attr = [], table_attr = [];
    this.customize_attribute.forEach(
      control => {
        if (control.data_type == 'table') { // for type table
          let tbl = { id: control.id, child: [] };
          tbl_attr.push(control.id);
          if (control.child.length > 0) {
            control.child.forEach((attr) => {
              tbl_attr.push(attr.id);
            });
            tbl.child = control.child;
          }
          table_attr.push(tbl);
        }
        if (tbl_attr.indexOf(control.id) == -1) {
          group.addControl('input_' + control.id, this.fb.control(''));
          if (control.measure_unit) group.addControl('unit_' + control.id, this.fb.control(''));
          if (control.child.length > 0) { // control for child attributes
            control.child.forEach(child => {
              group.addControl('input_' + child.id, this.fb.control(''));
              if (child.measure_unit) group.addControl('unit_' + child.id, this.fb.control(''));
              if (child.mutual.length > 0) { // control for child mutual attributes
                setTimeout(() => {
                }, 200);
                child.mutual.forEach(cm => {
                  group.addControl('input_' + cm.id, this.fb.control(''));
                  if (cm.measure_unit) group.addControl('unit_' + cm.id, this.fb.control(''));
                });
              }
            }
            );
          }
          if (control.mutual.length > 0) { // control for mutual exclussive attributes
            control.mutual.forEach(mutual => {
              group.addControl('input_' + mutual.id, this.fb.control(''));
              if (mutual.measure_unit) group.addControl('unit_' + mutual.id, this.fb.control(''));
            });
          }
        }
      }
    );
    table_attr.forEach((v) => { // form element for table type
      group.addControl('input_' + v.id, this.fb.control(''));
      let attrib_detail = this.fnc.getArrayValue('id', v.id, this.attribute_list);
      let master_val = this.getMasterById(attrib_detail.master_id);
      master_val.forEach((m) => {
        v.child.forEach((c) => {
          group.addControl('input_' + m.id + "_" + c.id, this.fb.control(''));
          if (c.measure_unit) group.addControl('unit_' + m.id + "_" + c.id, this.fb.control(''));
        });
      });
    });
    setTimeout(() => {
      this.patchFormData();
    }, 200);
    return group;
  }

  checkChild(attr, event, type) {
    let child = attr.child, val, mutual;
    let e = $(this.elementRef.nativeElement);
    if (child) {
      val = e.find("#input_" + attr.id).val();
      if (type == 'checkbox') {
        if (!event.target.checked) val = false;
      }
      child.forEach((v) => {
        if (val) {
          e.find("#input_" + v.id).prop('disabled', false);
        } else {
          e.find("#input_" + v.id).prop('disabled', true);
        }
        mutual = v.mutual;
        if (mutual) {
          mutual.forEach((m) => {
            if (val) {
              e.find("#input_" + m.id).prop('disabled', true);
            } else {
              e.find("#input_" + m.id).prop('disabled', true);
            }
          })
        }
      });
    }
  }

  // setAttributeValue(id, pid = null) { // not in use for now
  //   let result = null;
  //   if (this.property_detail) {
  //     let attribute = this.fnc.getArrayValue('id', id, this.attribute_list);
  //     let val = this.property_detail?.data;
  //     if (val[id]) {
  //       if (attribute.data_type != 'table') {
  //         // result = val[id];
  //         if (attribute.measure_unit) {
  //           //result = val[id].split(' ')[0];
  //         }
  //       }
  //     }
  //   }
  //   return result;
  // }

  formatDate(value) {
    return value.getFullYear() + "-" + (value.getMonth() + 1).toString().padStart(2, 0) + "-" + value.getDate().toString().padStart(2, 0);
  }
  patchFormData() {
    let e = $(this.elementRef.nativeElement);
    let data = {}, patchData = {}, pval;
    if (this.property_detail?.data) {
      data = this.property_detail?.data;
    }
    if (data) {
      let val = null, key, unit_key, control;
      let rec = {}, unit_rec = {};
      this.attribute_list.forEach((v) => {
        if (!v.is_editable) {
          setTimeout(() => {
            e.find("#input_" + v.id).addClass("disabled-div");
            e.find("#unit_" + v.id).addClass("disabled-div");
          }, 200);
        }
        let attrib_detail = this.fnc.getArrayValue('id', v.id, this.customize_attribute);
        if (data[v.id] && !v.is_hidden && v.status) {

          key = 'input_' + v.id;
          if (v.data_type != 'table') {

            if (v.measure_unit && String(data[v.id]).indexOf(' ') != -1) {
              let unit_data = data[v.id].split(' ');
              rec[key] = unit_data[0];
              if (unit_data[1]) {
                unit_key = "unit_" + v.id;
                unit_rec[unit_key] = unit_data[1];
                this.propertyForm.patchValue(unit_rec);
              }

            } else {
              val = data[v.id];
              if (v.data_type == 'year' || v.data_type == 'month') { // convert each value to string
                val = String(val);
              }
              if (v.data_type == 'date') { // convert each value to string
                val = this.formatDate(new Date(val));
              }
              if (v.data_type == 'single-select') val = String(val);
              if (v.data_type == 'single-select' && attrib_detail) {
                val = String(val);
                if (attrib_detail.child.length) {
                  pval = val;
                  setTimeout(() => {
                    this.changeChild(pval, attrib_detail,true); // patch value of child element
                  }, 600);
                }
              }
              if (v.data_type == 'multi-select') { // convert each value of multi select to string
                if (val.length > 0) {
                  if (attrib_detail) { // patch value of child element
                    if (attrib_detail.child.length) {
                      pval = val;
                      setTimeout(() => {
                        this.changeMultiChild(pval, attrib_detail,true);
                      }, 600);
                    }
                  }
                  let multi_val = [];
                  val.forEach((multi) => {
                    multi_val.push(String(multi));
                  });
                  val = multi_val;
                } else {
                  val = null;
                }
              }
              rec[key] = val;
            }
            if (attrib_detail?.mutual.length) { // for mutual attribute condition

              if (data[attrib_detail.id]) {
                setTimeout(() => {
                  e.find("#radio_" + attrib_detail.id + "_1").prop('checked', true);
                }, 200);
                attrib_detail.mutual.forEach((mt) => {
                  patchData["input_" + mt.id] = null;
                  this.propertyForm.patchValue(patchData);
                });
              }
              if (attrib_detail.child.length) {
                attrib_detail.child.forEach((c) => {
                  if (data[c.id]) {
                    setTimeout(() => {
                      e.find("#radio_" + c.id + "_1").prop('checked', true);
                    }, 200);
                  }
                  if (c.mutual.length) {
                    c.mutual.forEach((m) => {
                      if (data[m.id]) {
                        setTimeout(() => {
                          e.find("#radio_" + c.id + "_2").prop('checked', true);
                          e.find("#div_" + c.id + "_1").addClass("disabled-div");
                          e.find("#input_" + c.id).addClass("disabled-div");
                          e.find("#div_" + c.id + "_2").removeClass("disabled-div");
                        }, 200);
                      }
                    })
                  }
                })
              }
            }
            this.propertyForm.patchValue(rec);
          }
          if (v.data_type == 'table') {
            if (data[v.id].length > 0) {
              let record = data[v.id];
              let master_val = this.getMasterById(v.master_id);
              let attrib_detail = this.fnc.getArrayValue('id', v.id, this.customize_attribute);
              master_val.forEach((m) => {
                if (attrib_detail.child.length > 0) {
                  let attr_m = this.fnc.getArrayValue('0', m.id, record);
                  if (!attr_m) return;
                  attrib_detail.child.forEach((c) => {
                    key = 'input_' + m.id + '_' + c.id;
                    if (!c.is_hidden && c.status) {
                      if (c.measure_unit && String(attr_m[c.id]).indexOf(' ') != -1) {
                        let unit_data = attr_m[c.id].split(' ');
                        rec[key] = unit_data[0];
                        if (unit_data[1]) {
                          unit_key = 'unit_' + m.id + '_' + c.id;
                          unit_rec[unit_key] = unit_data[1];
                          this.propertyForm.patchValue(unit_rec);
                        }
                      } else {
                        val = attr_m[c.id];
                        if (c.data_type == 'year' || c.data_type == 'month') { // convert each value to string
                          val = String(val);
                        }
                        if (c.data_type == 'multi-select') { // convert each value of multi select to string
                          if (val) {
                            if (val.length > 0) {
                              let multi_val = [];
                              val.forEach((multi) => {
                                multi_val.push(String(multi));
                              });
                              val = multi_val;
                            } else {
                              val = null;
                            }
                          }
                        }
                        rec[key] = val;
                      }
                      this.propertyForm.patchValue(rec);
                    }
                  });
                }
              });
            }
          }
        } else {

          if (attrib_detail?.mutual.length) {
            attrib_detail.mutual.forEach((m) => {
              if (data[m.id]) {
                setTimeout(() => {
                  e.find("#radio_" + attrib_detail.id + "_2").prop('checked', true);
                  this.hideElement(attrib_detail.id);
                  e.find("#div_" + attrib_detail.id + "_1").addClass("disabled-div");
                  e.find("#input_" + attrib_detail.id).addClass("disabled-div");
                  e.find("#div_" + attrib_detail.id + "_2").removeClass("disabled-div");
                  patchData["input_" + attrib_detail.id] = null;
                  this.propertyForm.patchValue(patchData);
                }, 300);

              } else {
                setTimeout(() => {
                  e.find("#radio_" + attrib_detail.id + "_1").prop('checked', true);
                }, 300);
              }
            });
            if (attrib_detail.child.length) {
              attrib_detail.child.forEach((c) => {
                if (data[c.id]) {
                  setTimeout(() => {
                    e.find("#radio_" + c.id + "_1").prop('checked', true);
                  }, 200);
                }
                if (c.mutual.length) {
                  c.mutual.forEach((m) => {
                    if (data[m.id]) {
                      setTimeout(() => {
                        e.find("#radio_" + c.id + "_2").prop('checked', true);
                        e.find("#div_" + c.id + "_1").addClass("disabled-div");
                        e.find("#input_" + c.id).addClass("disabled-div");
                        e.find("#div_" + c.id + "_2").removeClass("disabled-div");
                      }, 200);
                    } else {
                      setTimeout(() => {
                        e.find("#radio_" + c.id + "_1").prop('checked', true);
                      }, 200);
                    }
                  })
                }
              })
            }
          }

          // patch default value
          if (v.data_type != "table") {
            key = "input_" + v.id;
            unit_rec[key] = v.default_value;
            this.propertyForm.patchValue(unit_rec);
            if (v.measure_unit) {
              unit_key = "unit_" + v.id;
              rec[unit_key] = v.measure_unit;
              this.propertyForm.patchValue(rec);
            }
          }

        }
        // patch default value of table
        if (v.data_type == 'table') {
          let record = data[v.id];
          let master_val = this.getMasterById(v.master_id);
          let attrib_detail = this.fnc.getArrayValue('id', v.id, this.customize_attribute);
          if (attrib_detail) {
            master_val.forEach((m) => {
              let attr_m = this.fnc.getArrayValue('0', m.id, record);
              if (attrib_detail.child.length > 0) {
                attrib_detail.child.forEach((c) => {
                  if (!c.is_hidden && c.status) {
                    if (c.measure_unit) {
                      unit_key = 'unit_' + m.id + '_' + c.id;
                      unit_rec[unit_key] = c.measure_unit;
                      this.propertyForm.patchValue(unit_rec);
                      if((attr_m && !attr_m[c.id]) || !attr_m) {
                        key = 'input_' + m.id + '_' + c.id;
                        rec[key] = c.default_value;
                        this.propertyForm.patchValue(rec);
                      }
                    } else if((attr_m && !attr_m[c.id]) || !attr_m) {
                      key = 'input_' + m.id + '_' + c.id;
                      rec[key] = c.default_value;
                      this.propertyForm.patchValue(rec);
                    }
                  }
                });
              }
            });
          }

        }
      });
    }
  }



  createProperty(event, isClosed:boolean=true) {
    this.is_valid = true;
    if (!this.resource_access.PATCH) {
      if (this.share.block0_obj.entity_type == "property_unit") this.notify.notify("You are not authorized to update property unit", 'warn');
      return;
    }
    let updatedAttribute = 0;
    let preVal = [];
    if (this.property_detail) {
      if (this.property_detail?.data) {
        preVal = this.property_detail?.data;
      }
    }
    let value = event.value;
    let x, attr_id, unit = '', attribute_c, attribute, lang_attribute = {}, simple_attribute = {}, val;
    let data = {}, body = {}, used_attr = [], table_attr = [];
    let e = $(this.elementRef.nativeElement);
    for (x in value) {
      let s = x.split('_');
      if (s[0] === 'search') {
        continue;
      }
      if (x.indexOf('unit') == -1) {
        unit = '';
        let attr_array = x.split('_');
        let attr_id = attr_array[attr_array.length - 1]; // last index wil be attribute id
        e.find("#input_" + attr_id).removeClass("red-border");
        attribute_c = this.fnc.getArrayValue('id', attr_id, this.customize_attribute);
        attribute = this.fnc.getArrayValue('id', attr_id, this.attribute_list);
        if (attribute.is_editable && !attribute.is_hidden && attribute.status) {
          if (attribute.data_type == 'table') { // for type table
            let tbl = { id: attribute_c.id, child: [] };
            used_attr.push(attribute_c.id);
            if (attribute_c.child.length > 0) {
              attribute_c.child.forEach((attr) => {
                used_attr.push(attr.id);
              })
              tbl.child = attribute_c.child;
            }
            table_attr.push(tbl);
          }
          if (used_attr.indexOf(+attr_id) == -1) {
            if (attribute.measure_unit) {
              e.find("#unit_" + attr_id).removeClass("red-border");
              unit = value["unit_" + attr_id];
              val = null;
              if (unit && value[x]) val = value[x] + " " + unit;
              if ((!unit || !value[x]) && attribute.is_mandatory) {
                e.find("#unit_" + attr_id).addClass("red-border");
                e.find("#input_" + attr_id).addClass("red-border");
                this.is_valid = false;
                val = null;
              }
            } else {
              val = value[x];
              if (!val && attribute.is_mandatory) {
                if(attribute.data_type == 'toggle'){
                  document.getElementById("toggle_"+attr_id).classList.add("red-border");
                }else{
                  e.find("#input_" + attr_id).addClass("red-border");
                }
                this.is_valid = false;
              }else if(attribute.data_type == 'toggle'){
                document.getElementById("toggle_"+attr_id).classList.remove("red-border");
              }

            }
            if (attr_id == this.share.block0_obj.property_name_attr_id && val) {
              let _building_name = { [this.api.language.toString()]: val };
              body['own_address'] = {
                'building_name': _building_name
              }; // synching own address
            }
            let oldVal = (preVal[attr_id]) ?? null;
            if (attribute.data_type == "toggle" && !val) {
              val = false;   // set false value to toggel in case of null value
              if (!oldVal) oldVal = false;
            }
            if (attribute.data_type == "date" && !val) {
              val = null;   // set false value to toggel in case of null value
            }
            if (attribute.data_type == "date" && val) {
              val = this.formatDate(new Date(val));
            }
            if ((attribute.data_type == "toggle" && val != oldVal) || this.compairValue(val, oldVal)) { // send only changed value
              //updatedAttribute++;

              if (attribute.data_type == 'single-select') {// convert empty string value to null
                if(val === ''){
                  val = null;
                }
              }

              if (attribute.data_type == 'multi-select') { // convert each value to integer
                if (val.length > 0) {
                  let multi_val = [];
                  val.forEach((multi) => {
                    if (multi) multi_val.push(parseInt(multi));
                  });
                  val = multi_val;
                } else {
                  val = null;
                }
              }
              if (attribute.data_type == 'year' || attribute.data_type == 'month') { // convert each value to integer
                val = parseInt(val);
              }
              if (attribute.is_mandatory && !val) {  // null value is not allow in mandatory case

              } else {
                if (attribute.is_lang_dependent) {
                  lang_attribute[attr_id] = val;
                }
                if (!attribute.is_lang_dependent) {
                  simple_attribute[attr_id] = val;
                }
              }
            }

          }
        }
      }
    }
    if (table_attr.length > 0) { // get data of table type attribute
      table_attr.forEach((v) => {
        let tbl_val = [];
        let attrib_detail = this.fnc.getArrayValue('id', v.id, this.attribute_list);
        let master_val = this.getMasterById(attrib_detail.master_id);
        let record = preVal[v.id];
        master_val.forEach((m) => {
          let tbl = {};
          tbl["0"] = m.id;
          v.child.forEach((c) => {
            if (c.is_editable && !c.is_hidden && c.status) {
              if (c.measure_unit) {
                e.find("#unit_" + m.id + "_" + c.id).removeClass("red-border");
                val = value["input_" + m.id + "_" + c.id];
                if(val){
                  unit = value["unit_" + m.id + "_" + c.id];
                  val = val + " " + unit;
                }else{ // make it null if no value is set
                  val = null;
                }
                if ((!unit || !value["input_" + m.id + "_" + c.id]) && attribute.is_mandatory) {
                  e.find("unit_" + m.id + "_" + c.id).addClass("red-border");
                  this.is_valid = false;
                  val = null;
                }

                if ((!unit || !value["input_" + m.id + "_" + c.id])) {
                  e.find("unit_" + m.id + "_" + c.id).addClass("red-border");
                  this.is_valid = false;
                  val = null;
                }
              } else {
                val = value["input_" + m.id + "_" + c.id];
                if (!val && c.is_mandatory) {
                  document.getElementById("input_" + m.id + "_" + c.id).classList.add("red-border");
                  this.is_valid = false;
                }else{
                  document.getElementById("input_" + m.id + "_" + c.id).classList.remove("red-border");
                }
              }

              if (val != '' || val != null){ //  && this.compairValue(val,oldVal)
                //updatedAttribute++;
                if (c.data_type == 'multi-select') { // convert each value to integer
                  if (val && val.length > 0) {
                    let multi_val = [];
                    val.forEach((multi) => {
                      if (multi) multi_val.push(parseInt(multi));
                    });
                    val = multi_val;
                  } else {
                    val = null;
                  }
                }
                if (c.data_type == 'year' || c.data_type == 'month') { // convert each value to integer
                  val = parseInt(val);
                }
                if (c.data_type == 'number-input' && !c.measure_unit) {
                  tbl[c.id] = + val;
                } else {
                  tbl[c.id] = val;
                }
              }
            }
          });

          if (this.fnc.jsonLength(tbl) > 1) tbl_val.push(tbl);
        });
        if (attrib_detail.is_lang_dependent && tbl_val.length) {
          lang_attribute[v.id] = tbl_val;
        }
        if (!attrib_detail.is_lang_dependent && tbl_val.length) {
          simple_attribute[v.id] = tbl_val;
        }
      });
    }
    if (this.fnc.jsonLength(lang_attribute) || this.fnc.jsonLength(simple_attribute)) updatedAttribute = 1;
    if(!this.is_valid){
      this.notify.notify('Required Field cannot be empty', 'warn');
      return
    }
    if (updatedAttribute) {
      data["0"] = simple_attribute;
      data[this.api.language] = lang_attribute;
      body["data"] = data;
      if (this.property_detail.status == 4) {
        body["status"] = 6;
        if (this.property_detail.attribute_info) {
          for (let key in this.property_detail.attribute_info) {
            if (this.property_detail.attribute_info[key].status == -1) { // -1 is rejected, 3 edited by user.
              this.property_detail.attribute_info[key].status = 3;
            } else {
              this.property_detail.attribute_info[key].status = 1;
            }
          }
          body["attribute_info"] = this.property_detail.attribute_info;
        }
      }

      body["updated_by"] = this.api.user_id;
      body["assignment_id"] = this.share.block0_obj.assignment_id;
      let url = "";

      if (this.share.block0_obj.entity_type == 'property_unit') {
        url = "deadmin/" + this.assignment_detail.assignment_name + "/properties/" + this.share.block0_obj.selected_property.id + "/floors/" + this.share.floor_obj.selected_floor_id + "/units/" + this.unit.id;
      }
      this.share.main_property_obj.gLoader = true;
      this.subscriptions.add( this.api.patchEpsData(url, body)
        .subscribe({next:(data: any) => {
          this.share.main_property_obj.gLoader = false;
          this.notify.notify('Information Updated', 'success');
          if (this.share.block0_obj.entity_type == 'property_unit') {
            this.share.unit_obj.getUnitDetail();
          }
          setTimeout(() => {
            this.setPropertyDetail();
          }, 3000);
          if(isClosed) this.closeDialog();
        },
          error:(err) => {
            this.share.main_property_obj.gLoader = false;
          }}));
    }
  }

  compairValue(val1, val2) {
    let res = true;
    if (!val1 && !val2) res = false;
    if (val1 && val2) {
      if (val1.toString() == val2.toString()) res = false;
    }
    return res;
  }

    // grouping attributes
    public createFormGroup() {
      let val = {}, new_list = [];
      let mtl = [];
      this.masterIDs = [];
      this.attribute_list.forEach((v) => {
        if (v['master_id']) {
          this.masterIDs.push({
            master_id: v.master_id,
            attribute_id: v.id
          })
        }
        if (this.mobile) {
          if (v.data_type == 'images' || v.data_type == 'videos') {
            this.route.navigateByUrl('uploadMedia');
            return;
          }
        } else if (v.data_type == 'images' || v.data_type == 'videos') {
            if (this.share.floor_obj) {
              if (this.share.floor_obj.selected_floor) {
                setTimeout(() => {
                  this.notif.emit('upload_Media_unit');
                }, 200);
              }
            }
            setTimeout(() => {
              this.notif.emit('uploadMedia');
            }, 400);
            return;
        }
        val = {
          id: v.id,
          name: v.name,
          parent_id: v.parent_id,
          label: v.label,
          data_type: v.data_type,
          measure_type: v.measure_type,
          measure_unit: v.measure_unit,
          default_value: v.default_value,
          is_mandatory: v.is_mandatory,
          is_hidden: v.is_hidden,
          is_editable: v.is_editable,
          status: v.status,
          mutually_exclusive: v.mutually_exclusive,
          master_id: v.master_id,
          has_linked_master : v.has_linked_master,
          dependent: v.dependent,
          mutual: [],
          child: []
        }
        new_list.push(val);
      });
      new_list.forEach((v) => {
        if (v.mutually_exclusive) {
          v.mutually_exclusive.forEach((m) => {
            this.used_attribute.push(m);
            mtl.push(this.fnc.getArrayValue('id', m, new_list));
          });
          v.mutual = mtl;
        }
        if (v.parent_id) {
          this.used_attribute.push(v.id);
          let index = this.fnc.getArrayindex('id', v.parent_id, new_list);
          if (index !== null) {
            new_list[index].child.push(v);
          }
        }
      });
      this.group_attribute = new_list;
      this.customize_attribute = this.fnc.getDeletedArray('id', this.used_attribute, new_list); // remove duplicate list
      this.createattributesGroup();
    }

  changeChild(event, attrib, onload = false) {
    let val = event;
    if (val == 'addNewOption') {
      return;
    }
    if (val) {
      if (attrib.child.length) {
        let fld = null;
        attrib.child.forEach((child) => {
          this.linked_master = [];
          this.child_master_val[child.id] = [];
          if (child.data_type == "single-select" || child.data_type == "multi-select") {
            this.child_master_val[child.id] = this.getMasterByValueId(child, +val);
            if (child.has_linked_master) {
              fld = 'input_' + child.id;
              if ((!this.propertyForm.get('input_' + child.id).value && onload) || !onload && child.data_type == "single-select") {
                  this.propertyForm.patchValue({ [fld]: this.linked_master.length>0 ? this.linked_master[0] : '' });
              }else if(child.data_type == "multi-select"){
                  this.propertyForm.patchValue({ [fld]: this.linked_master });

                }
            }
          }
        });
      }
    }
  }

  changeMultiChild(event, attrib, onload = false) {
    let val = event;
    let fld = null;
    let last_val: any = [];
    let new_val: any = [];
    let final_val: any = [];
    if (val) {
      if (attrib.child.length) {
        attrib.child.forEach((child) => {
          this.child_master_val[child.id] = [];
          if (child.data_type == "single-select" || child.data_type == "multi-select") {
            this.linked_master = [];
            val.forEach((v) => {
              fld = null;
              if (this.child_master_val[child.id].length) {
                last_val = this.child_master_val[child.id];
              }
              new_val = this.getMasterByValueId(child, +v);
              if (new_val.length) {
                final_val = new_val;
              }
              if (last_val.length) {
                final_val = last_val;
              }
              if (last_val.length && new_val.length) {
                final_val = new_val.concat(last_val);
              }
              this.child_master_val[child.id] = final_val;
              if (child.has_linked_master) {
                this.linked_master = this.fnc.removeDuplicateKey(this.linked_master);// remove duplicate value
                fld = 'input_' + child.id;
                if ((!this.propertyForm.get('input_' + child.id).value && onload) || !onload) {
                  if(child.data_type == "single-select"){
                    this.propertyForm.patchValue({ [fld]: this.linked_master.length > 0 ? this.linked_master[0]: ''});
                  }else if(child.data_type == "multi-select") {
                    this.propertyForm.patchValue({ [fld]: this.linked_master });
                  }
                }
              }
            });
          }
        });
      }
    }
  }

  getChildMasterValue(attrib, parent) {
    let res = [];
    let id = attrib.id;
    if (parent.data_type == "single-select" || parent.data_type == "multi-select") {
      if (this.child_master_val[id]) {
        res = this.child_master_val[id];
      }
      return res;
    } else {
      return this.getMasterById(attrib.master_id);
    }

  }

  getMasterValue() {
    let master_list = [];
    this.masters.forEach((v) => {
      if (master_list.indexOf(v) == -1) {
        master_list.push(v);
      }
    });
    if (master_list.length > 0) {
      master_list.forEach((v) => {
        if (this.share.block0_obj.table_master.indexOf(v) == -1) {
          let url = "property/masters/" + v + "/values?sort_by=master_value_name&limit=1000&offset=0";
           this.subscriptions.add(this.api.getEmsData(url)
            .subscribe((data:any) => {
              data?.forEach(element => {
                let val = {
                  master_id: v,
                  name: element.master_value_name,
                  label: element.master_value_label[this.api.language],
                  id: element.master_value_id,
                  status: element.status,
                  property_type_id: element.property_type_id,
                  master_value_id: element.parent_master_value_id
                };
                this.master_val.push(val);
              });
            }));
        }
      });
    }

  }

  getMasterById(master_id) {
    let record = [];
    record = this.fnc.getChildArray('master_id', master_id, this.master_val);
    return record;
  }

  // getMasterByValueId(master_id, master_value_id) {
  //   let record = [];
  //   let sub_master = this.fnc.getChildArray('master_id', master_id, this.master_val);
  //   console.log(sub_master);

  getMasterByValueId(attrib, master_value_id) {
    let master_id = attrib.master_id;
    let record = [];
    let sub_master = this.fnc.getChildArray('master_id', master_id, this.master_val);
    if(attrib.has_linked_master){
      record = sub_master;
      sub_master.forEach((v)=>{
        if(v.parent_master_value_ids){
          let ms = v.parent_master_value_ids.split(",");
          if(ms.indexOf(''+master_value_id) > -1){
            this.linked_master.push((''+v.id).trim());
          }
        }
      });
    }else{
      record = this.fnc.getChildArray('master_value_id', master_value_id, sub_master);
    }
    return record;
  }

  createattributesGroup() {
    this.customize_attribute = [];
    let list = this.attribute_list;
    let val: any;
    this.attribute_list.forEach((v, k) => {
      val = {
        id: v.id,
        name: v.name,
        label: v.label,
        data_type: v.data_type,
        measure_type: v.measure_type,
        measure_unit: v.measure_unit,
        default_value: v.default_value,
        is_mandatory: v.is_mandatory,
        is_hidden: v.is_hidden,
        is_editable: v.is_editable,
        is_lang_dependent: v.is_lang_dependent,
        status: v.status,
        master_id: v.master_id,
        dependent: [],
        mutual: [],
        child: []
      }
      if (!val.label) {
        val.label = v.name;
      }
      if (v.mutually_exclusive) {
        v.mutually_exclusive.forEach((mtl) => {
          let mtl_val = this.fnc.getArrayValue('id', mtl, this.group_attribute);
          val.mutual.push(mtl_val);
        });
      }
      list.forEach((prt) => {
        if (prt.parent_id === v.id) {
          let prt_obj = this.fnc.getArrayValue('id', prt.id, this.group_attribute);
          val.child.push(prt_obj);
        }
      });
      this.customize_attribute.push(val);
    });
    this.used_attribute.forEach((v, k) => {
      this.customize_attribute = this.fnc.getDeletedArray('id', v, this.customize_attribute); // remove duplicate list
    });
    this.propertyForm = this.createFormElement();
  }

  getMeasureUnit(val) {
    if (val) {
      let units = this.fnc.getArrayValue('unit_type', val, this.measure_unit_type);
      if (units) {
        return units.measure_unit;
      }
    }
    return [];
  }

  getUnitByType(val) {
    if (val) {
       this.subscriptions.add(this.api.getEmsData("attribute/" + val + "/measureunits")
        .subscribe(
          (data:any) => {
            this.measure_unit_type.push({
              unit_type: val,
              measure_unit: data
            });
            localStorage.setItem('measure_unit_type',JSON.stringify(this.measure_unit_type));
          }
       ));
    }
  }
  getMeasureUnitType() {
    let units = JSON.parse(localStorage.getItem('measure_unit_type'))
    if(units){
      this.measure_unit_type = units;
      return;
    }
    let url = "attribute/measureunittypes";
     this.subscriptions.add(this.api.getEmsData(url).subscribe(
      (data:any) => {
        data.forEach((v) => {
          this.getUnitByType(v);
        });
      }
    ));
  }

  showChild(attr, num, event = null) {
    let id = attr.id;
    let patchData = {};
    let e = $(this.elementRef.nativeElement);
    //this.propertyForm.controls.nam
    if (event.target.value == 'on') {
      e.find('#child_' + id).removeClass('hidden');
    } else {
      e.find('#child_' + id).addClass('hidden');
    }
    if (num == 1) {
      e.find("#div_" + id + "_2").addClass("disabled-div");
      e.find("#input_" + id).removeClass("disabled-div");
      e.find("#div_" + id + "_1").removeClass("disabled-div"); // special case for toggle
      if (attr.data_type == "toggle") {
        e.find("#input_" + id).prop('checked', true);
        patchData["input_" + id] = true;
      } else {
        patchData["input_" + id] = null;
      }
      if (attr.mutual.length) {
        attr.mutual.forEach((c) => {
          patchData["input_" + c.id] = null;
          this.propertyForm.patchValue(patchData);
        });
      }

    }
    if (num == 2) {
      e.find("#div_" + id + "_2").removeClass("disabled-div");
      e.find("#div_" + id + "_1").addClass("disabled-div");
      e.find("#input_" + id).addClass("disabled-div");
      if (attr.data_type == "toggle") {
        e.find("#input_" + id).prop('checked', false);
        patchData["input_" + id] = false;
      } else {
        patchData["input_" + id] = null;
      }
      this.propertyForm.patchValue(patchData);
      if (attr.child.length) {
        attr.child.forEach((c) => {
          patchData["input_" + c.id] = null;
          this.propertyForm.patchValue(patchData);
          if (c.mutual.length) {
            c.mutual.forEach((m) => {
              patchData["input_" + m.id] = null;
              this.propertyForm.patchValue(patchData);
            });
          }
        });
      }

    }
  }

  hideElement(id) {
    let e = $(this.elementRef.nativeElement);
    e.find('#child_' + id).addClass('hidden');
  }

  backClicked() {
    this.is_submited = true;
    if (this.is_valid) {
      this.location.back();
    } else {
      let dialogRef = this.dialog.open(ConfirmExit, {
        width: '350px',
        panelClass: 'create-master-panel',
        data: this
      });
       this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      }));
    }
  }

  submitForm() {
    if(!this.is_submited){
      this.is_submited = true;
      let e = $(this.elementRef.nativeElement);
    e.find("#property_form_btn").trigger('click');
    }
  }
  onResize(event) {
    let height = event.target.innerHeight - 100;
    this.dHeight = height;
    let e = $(this.elementRef.nativeElement);
    e.find('#pList').css('height', this.dHeight);
    e.find('#DynamicBlock').css('height', (this.dHeight - 50));
  }
  ngOnInit() {
    if (!this.share.block1_obj) {
      this.route.navigateByUrl('/');
      return;
    }
    this.setPropertyDetail();
    this.getAttributeValue();
  }

  getAttributeValue() {
    let data = this.property_detail?.data;
    this.masterIDs.forEach((e) => {
      if (data[e.attribute_id] && _isNumberValue(data[e.attribute_id])) {
        this.getMasterValues(e.master_id, data[e.attribute_id]);
      }
    });
  }
  getMasterValues(v, masterValueIds = null) {
    let m_val = this.getMasterById(v);
    if (masterValueIds == null) return;

    let url = this.share.block0_obj.entity_type + "/masters/" + v + "/values?sort_by=master_value_name&limit=100&offset=0&status=1";
    if (this.share.block0_obj.property_type_id && this.share.block0_obj.entity_type == "property_unit") {
      url += "&property_type_ids=" + this.share.block0_obj.property_type_id;
    }
    if (masterValueIds) {
      url += '&master_value_ids=' + masterValueIds.toString();
    }
    let curMaster: any;
     this.subscriptions.add(this.api.getEmsData(url)
      .subscribe((data: any) => {
        data?.forEach(element => {
          let val = {
            label: element.master_value_label[this.api.language],
            labels: element.master_value_label,
            master_id: v,
            master_name: element.master_value_name,
            id: element.master_value_id,
            status: element.status,
            property_type_id: element.property_type_id,
            master_value_id: element.parent_master_value_id,
            parent_master_value_ids: element.parent_master_value_ids,
            name: element.master_value_label[this.api.language] // adding this for drop down
          };
          curMaster = this.fnc.getArrayValue('id', val.id, m_val);
          if (curMaster == null) {
            this.master_val.push(val);
          }
        });
      }));
  }

  closeDialog() {
    this.dialogRef.close();
  }
  //MULTI SELECT RELATED========================================================================================================
  //MULTI SELECT RELATED========================================================================================================

  getList(attrib, s, parent = null) {
    let l;
    if (parent) {
      l = this.getChildMasterValue(attrib, parent)
    } else {
      l = this.getMasterById(attrib.master_id);
    }

    if (!s || this.active_field.id != attrib.id) {
      return l;
    }
    if (this.newlist) {
      return this.newlist;
    } else {
      return l;
    }
  }

  getSelectedValues(attrib, single = false) {//getting selected values for multiselect dropdown
    let selected = this.propertyForm.get('input_' + attrib.id).value;
    if (!single) {
      if (selected?.length) {
        this.selectedValues.push({
          attr_id: attrib.id,
          selected: selected
        })
        $('#input_custom_' + attrib.id).val(selected.length + " values selected");
      } else {
        $('#input_custom_' + attrib.id).val("No values selected");
      }
    } else if (selected && single) {
      let valObj = this.fnc.getArrayValue('id', selected, this.master_val);
      if (valObj != null) {
        let val = (valObj.label) ?? valObj.master_name;
        if (val) $('#input_custom_' + attrib.id).val(val);
      }
    } else {
      $('#input_custom_' + attrib.id).val("No values selected");
    }
  }

  openMultiSelect(attrib, parent=null) {

    let selected;
    if(parent){
      selected = this.propertyForm.get('input_' + parent.id).value;
      if (!selected || (Array.isArray(selected) && selected.length === 0)) {
        this.notify.notify('Please select a parent value', 'warn');
        return;
      }
    }
    let dialogRef = this.dialog.open(MasterMultiselectFloorMap, {
      width: '450px',
      maxWidth: '95vw',
      maxHeight: '95vh',
      panelClass: 'create-master-panel',
      disableClose: true,
      data: {
        source: this,
        attrib: attrib,
        parent: parent,
        selected: this.selectedValues
      }
    });
     this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      this.createProperty(this.propertyForm, false);
    }));
  }

  onChanges(): void {
     this.subscriptions.add(this.propertyForm.valueChanges.subscribe(val => {
      this.is_submited = false;
    }));
    // for focus in case of mobile only
    if (this.mobile) {
      let e = $(this.elementRef.nativeElement);
      e.find(':input').on('focus', function () {
        setTimeout(() => {
          if(this.id) e.find("#" + this.id)[0].scrollIntoView();
        }, 350);
      });
    }
  }
  isRejected(id) {
    let attrib = this.fnc.getArrayValue('keyId', id, this.rejected_attribute);
    if (attrib != null) {
      if (attrib.keyId == id) {
        return true;
      }
    }
    return false;
  }
  setRejectedMessage(id) {

    let attrib = this.fnc.getArrayValue('keyId', id, this.rejected_attribute);
    if (attrib != null) {
      this.rejectmessage = attrib.comment;
    }
  }
  newValue(attrib, s, parent = null) {
    let l,val, i, flag:boolean = false;
    if (parent) {
      l = this.getChildMasterValue(attrib, parent);
    } else {
      l = this.getMasterById(attrib.master_id);
    }
    if (s) {
      s = s.toLowerCase();
      s = s.trim();
      for(i = 0; i<l.length; i++){
        val=l[i];
        if(val.label.toLowerCase() == s){
          flag = false;
          break;
        }else{
          flag = true;
        }
      }
      return flag;
    } else {
      return flag;
    }
  }

  // MAT SELECT SEARCH IMPLIMENTATION------------------------------------------------------
  find(str:any, attrib, parent = null) {
    str = str.target.value;

    if (str && str?.trim() == '') return;
    this.active_field = attrib;
    let list:any=[];
    if (parent) {
      list = this.getChildMasterValue(attrib, parent)
    } else {
      list = this.getMasterById(attrib.master_id);
    }


    if (str && list) {
      this.newlist = list.filter((e:any)=> e.label.toLowerCase().includes(str.toLowerCase()));
    }
  }
   ngOnDestroy() {
  this.subscriptions.unsubscribe();
  }
}



//Master multiselect=======================================================================================================
/**
 *
 * <strong>List of API using</strong>
 * <ol>
 * <li>estapi_entity_masters_master_id_values_get</li>
 * </ol>
 *
 */


@Component({
  selector: 'master-multiselect-floor-map',
  templateUrl: './master-multiselect/master-multiselect.html',
  styleUrls: ['../../master-multiselect.css']
})
export class MasterMultiselectFloorMap {
private subscriptions = new Subscription(); // initialize here
  editable: boolean = false;
  mobile: boolean = false;
  incoming: any;
  searchterm: string = '';
  list: any = [];
  filteredList: any = [];
  selectedValues: any = [];
  filteredSelectedValues: any = [];
  form_id: any;
  mt_error: boolean = false;
  selectedMaster: string = '';
  searchForm: UntypedFormControl;
  data_type: any;
  singleList: any = [];
  selectedItem: any = null;
  filteredSingleList: any = [];
  newList: any = [];
  tempVals: any = [];
  mainLoader: boolean = false;
  showAddButton: boolean = false;
  active_field: any = {
    id: null,
    label: null
  };

  constructor(public masterRef: MatDialogRef<MasterMultiselectFloorMap>, @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly api: ApiserviceService,
    private readonly share: ShareService,
    private readonly fnc: CommonfunctionService) {
    this.editable = data.attrib.is_editable;
    this.mobile = this.share.mobile;
    this.incoming = data.attrib;
    this.data_type = this.incoming.data_type;
    this.list = this.data.source.getList(this.incoming, '');
    this.form_id = 'input_' + data.attrib.id;
    this.getSelectedValues(this.data.selected);
    this.searchForm = new UntypedFormControl('', [
      Validators.required
    ]);
  }

  getSelectedValues(selected) {
    if (this.data_type == 'multi-select') {
      selected.forEach(element => {
        if (element.attr_id == this.data.attrib.id) {
          this.selectedValues = [];
          element.selected.forEach(id => {
            let val = this.fnc.getArrayValue('id', id, this.list);
            this.selectedValues.push(val);
          });
          this.filteredSelectedValues = this.selectedValues;
          this.tempVals = this.selectedValues;
        }
      });
    } else {
      this.singleList = this.list;
      this.filteredSingleList = this.singleList;
      if (this.data.source.propertyForm.get(this.form_id).value) {
        let id = this.data.source.propertyForm.get(this.form_id).value;
        this.selectedItem = this.fnc.getArrayValue('id', id, this.filteredSingleList);
        this.filteredSingleList = this.fnc.array_move(this.filteredSingleList, this.fnc.getArrayindex('id', id, this.filteredSingleList), 0);
      }
    }
    this.getList();
  }

  getList() {
    if (this.data_type == 'multi-select') {
      if (this.searchterm) {
        this.searchterm = this.searchterm.trim().toLowerCase();
        this.mainLoader = true;
        this.searchMasterApi(this.searchterm, this.incoming);
        this.filteredList = [];
        this.filteredSelectedValues = [];
        //filtering original values using searchterm
        this.list.forEach(e => {
          if (this.selectedValues.indexOf(e) == -1) {
            if (e.label.toLowerCase().includes(this.searchterm) && e.master_name.toLowerCase() == this.searchterm) {
                this.showAddButton = false;
              this.filteredList.push(e);
            } else if (e.master_name.toLowerCase().includes(this.searchterm)) {
              if (e.master_name.toLowerCase() == this.searchterm) {
                this.showAddButton = false;
              }
              if (this.selectedValues.length) {
                this.filteredList.push(e);
              }
            }
            if (!e.master_name.toLowerCase().includes(this.searchterm) && !e.label.toLowerCase().includes(this.searchterm)) {
              this.showAddButton = true;
            }
          }
        })
        //filtering selected values using searchterm
        this.selectedValues.forEach(val => {
          if (val.label.toLowerCase().includes(this.searchterm)) {
            if (val.label.toLowerCase() == this.searchterm) {
              this.showAddButton = false;
            }
            this.filteredSelectedValues.push(val);
          } else if (val.master_name.toLowerCase().includes(this.searchterm)) {
            if (val.master_name.toLowerCase() == this.searchterm) {
              this.showAddButton = false;
            }
            this.filteredSelectedValues.push(val);
          }
        });
      } else {
        this.mt_error = false;
        this.showAddButton = false;
        this.list.forEach(e => {
          if (this.selectedValues.indexOf(e) == -1) {
            this.filteredList.push(e);
          }
          this.filteredSelectedValues = this.selectedValues;
        })
      }
    } else if (this.searchterm) {
      //filtering single select values using searchterm
        this.searchterm = this.searchterm.trim().toLowerCase();
        this.mainLoader = true;
        this.searchMasterApi(this.searchterm, this.incoming);
        this.filteredSingleList = [];
        this.singleList.forEach((slist) => {
          if (slist.label.toLowerCase().includes(this.searchterm)) {
            if (slist.label.toLowerCase() == this.searchterm) {
              this.showAddButton = false;
            }
            this.filteredSingleList.push(slist);
          } else if (slist.master_name.toLowerCase().includes(this.searchterm)) {
            if (slist.master_name.toLowerCase() == this.searchterm) {
              this.showAddButton = false;
            }
            if (this.selectedValues.length) {
              this.filteredSingleList.push(slist);
            }
          }
          if (!slist.master_name.toLowerCase().includes(this.searchterm) && !slist.label.toLowerCase().includes(this.searchterm)) {
            this.showAddButton = true;
          }
        });
      } else {
        this.showAddButton = false;
        this.filteredSingleList = this.singleList;
    }
  }

  clear() {
    this.searchForm.setValue('');
    this.getList();
    this.filteredSelectedValues = this.tempVals;
  }

  // add() {
  //   if (this.searchterm && this.data.attrib)
  //     this.data.source.searchTerm = this.searchterm;
  //   this.data.source.active_field = this.data.attrib;
  //   this.data.source.addNewMasterValue(this.searchterm, this.data.attrib, this.data.parent, this.selectedMaster);
  //   this.masterRef.close();
  // }

  save() {
    this.selectedValues = this.tempVals;
    let ids = [], values = {};
    this.selectedValues.forEach((id) => {
      ids.push(id.id);
    })
    values = {
      [this.form_id]: ids
    };
    this.data.source.propertyForm.patchValue(values);

    if(!this.data.parent){ // reset all child value if parent is null
      let parent_selected_values = values[this.form_id];
      if(parent_selected_values.length === 0){
        if(this.data.attrib?.child?.length){
          this.data.attrib.child.forEach(ch => {
            let ch_form_id = 'input_' + ch.id;
            if(ch.data_type == 'single-select'){
              this.data.source.propertyForm.patchValue({
                [ch_form_id]: null
              })
            }else if (ch.data_type == 'multi-select'){
              this.data.source.propertyForm.patchValue({
                [ch_form_id]: []
              })
            }

          });
        }
      }
    }


    this.data.source.changeMultiChild(ids, this.incoming);
    this.masterRef.close();
  }
  saveSingle() {
    this.searchterm = '';
    let values = {
      [this.form_id]: this.selectedItem.id
    };
    this.data.source.changeChild(this.selectedItem.id, this.incoming);
    this.data.source.propertyForm.patchValue(values);
    this.masterRef.close();
  }

  drop(event: CdkDragDrop<string[]>, direction) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
      if (!this.searchterm) {
        if (direction == 'right' && event.container.data.length) {
            this.tempVals = event.container.data;
        } else if (direction == 'left' && event.container.data.length) {
            event.container.data.forEach((val: any) => {
              this.tempVals = this.fnc.getDeletedArray('id', val.id, this.tempVals);
            })
        }
      } else if (this.searchterm) {
        if (direction == 'right' && event.container.data.length) {
            event.container.data.forEach((val: any) => {
              if (this.fnc.getArrayindex('id', val.id, this.tempVals) == null) {
                this.tempVals.push(val);
              };
            })
        } else if (direction == 'left' && event.container.data) {
            event.container.data.forEach((val: any) => {
              if (val) this.tempVals = this.fnc.getDeletedArray('id', val.id, this.tempVals);
            })
        }
      }
    }
  }

  selectItem(i) {
    this.selectedItem = i;
  }

  cancel() {
    this.masterRef.close();
    this.clear();
    this.data.source.active_field = null;
  }


  searchMasterApi(str, attrib) {
    str = str.toLowerCase();
    let url = this.share.block0_obj.entity_type + "/masters/" + attrib.master_id + "/values?sort_by=sort_order&limit=100&offset=0&status=1&master_value_name=" + str;
    let curMaster: any;
     this.subscriptions.add(this.api.getEmsData(url)
      .subscribe({
        next: (data: any) => {
        this.newList = [];
        let label = '';
        this.mainLoader = false;
        data?.forEach((element, k) => {
          label = element.master_value_name;
          if (element.master_value_label[this.data.source.form_language]) {
            label = element.master_value_label[this.data.source.form_language];
          }
          let val = {
            label: label,
            labels: element.master_value_label,
            master_id: attrib.master_id,
            master_name: element.master_value_name,
            id: element.master_value_id,
            status: element.status,
            property_type_id: element.property_type_id,
            master_value_id: element.parent_master_value_id,
            parent_master_value_ids: element.parent_master_value_ids,
            name: label // adding this for drop down
          };
          if (this.data_type == 'multi-select') {
            curMaster = this.fnc.getArrayValue('id', val.id, this.list);
            if (curMaster == null) {
              this.data.source.master_val.push(val);
              this.filteredList.push(val);
            }
          } else {
            curMaster = this.fnc.getArrayValue('id', val.id, this.filteredSingleList);
            if (curMaster == null) {
              this.data.source.master_val.push(val);
              this.filteredSingleList.push(val);
            }
          }

          this.newList.push(val)
        });

      }, error:() => {
        this.mainLoader = false;
      }}));
  }



  ngOnInit() {
    this.searchForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe((val) => {
        this.searchterm = val;
        this.filteredList = [];
        this.getList();
      })
  }

     ngOnDestroy() {
  this.subscriptions.unsubscribe();
  }
}
